import type { Price, ProductPrice, ProductPrices } from '../../types';

export const getLowestPrice = (productPrices: ProductPrices | undefined): Price | undefined => {
    if (!productPrices || productPrices.length === 0) {
        return undefined;
    }

    return productPrices.reduce((lowest: Price | undefined, current: ProductPrice) => {
        if (!lowest || current.listPrice.taxed < lowest.listPrice.taxed) {
            return {
                currency: current.currency,
                listPrice: {
                    taxed: current.listPrice.taxed,
                    untaxed: current.listPrice.untaxed,
                },
            };
        }

        return lowest;
    }, undefined);
};
